(() => {
  function initializeContactVideos(root) {
    root.querySelectorAll('.art-contact-gallery').forEach((gallery) => {
      const button = gallery.querySelector('.art-contact-gallery__collection');
      const contact = document.querySelector('#MainContent .contact');
      if (!button || !contact || button.dataset.positionInitialized) return;
      button.dataset.positionInitialized = 'true';
      const desktop = window.matchMedia('(min-width: 990px)');
      const positionButton = () => {
        if (desktop.matches) contact.append(button);
        else gallery.prepend(button);
      };
      positionButton();
      desktop.addEventListener('change', positionButton);
    });
    root.querySelectorAll('.art-contact-gallery__video').forEach((video) => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      video.muted = true;
      video.loop = false;
      video.addEventListener('ended', () => {
        video.pause();
        // Keep the opening video frame visible without starting another play.
        video.currentTime = 0.001;
      });
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        // Start once when reached; native controls allow replay after it ends.
        video.play().catch(() => {});
      }, { threshold: 0.35 });
      observer.observe(video);
    });
  }
  initializeContactVideos(document);
  document.addEventListener('shopify:section:load', (event) => initializeContactVideos(event.target));
})();
